import React from 'react';

import Dossier from '../../../../components/Molecules/Dossier';

const DossierTeaser = ({ entity }) => {

  const typeMapper = {
    stage_of_life: 'Levensfase',
    workfield: 'Werkveld',
    subject: 'Onderwerp',
    locatie: 'Locatie',
  };

  return (
    <Dossier
      name={entity.getIn(['name', 0, 'value'], '')}
      type={typeMapper[entity.getIn(['vid', 0, 'target_id']) || null]}
      image={entity.getIn(['field_media_image', 0, 'styles', 'dossier_card'])}
      link={entity.getIn(['paths', 'nl'])}
    />
  );
};

export default DossierTeaser;
